// extracted by mini-css-extract-plugin
export default {"backButton":"TraineeRegistryArchivedDetails_backButton__TK2LI"};